import isNil from 'lodash/isNil';
import { formatNumberWithSpaces } from './formats';
import { getUnitLabel } from './units';
import Decimal from 'decimal.js';
import { EProductionUnit } from '@global-types/api/enum';

export const getConvertionFactor = (
	_conversionFactorOverride: number,
	_conversionFactor: {
		id: string;
		ratio: number;
		unit: string;
	}
) => {
	if (!_conversionFactorOverride) {
		return _conversionFactor
			? _conversionFactor.ratio
			: null;
	}
	return _conversionFactorOverride;
};

export const parseTokenEquivalentToTCO2E = (
	_convertionFactor: number | null,
	_quantity: number
) => {
	if (isNil(_convertionFactor)) {
		return '0 ' + getUnitLabel('tco2e');
	}
	return (
		formatNumberWithSpaces(
			Number(
				(
					Math.round(_convertionFactor * _quantity) /
					1000000
				).toFixed(3)
			)
		) +
		' ' +
		getUnitLabel('tco2e')
	);
};

/* -------------------------------------------------------------------------- */
/*                                   Numeric                                  */
/* -------------------------------------------------------------------------- */
export function convertKWHToMWHNumeric(kwh: number) {
	const _kwh = new Decimal(kwh);
	return Decimal.div(_kwh, 1000).toNumber();
}

export function convertKGToTNumeric(kg: number) {
	const _kg = new Decimal(kg);
	return Decimal.div(_kg, 1000).toNumber();
}

export function getNumericProduction(
	production: number,
	unit: string
) {
	switch (unit) {
		case EProductionUnit.KWH:
			return convertKWHToMWHNumeric(production);
		case EProductionUnit.KG:
			return convertKGToTNumeric(production);
		default:
			return 0;
	}
}

export function getNumericTokenEquivalent(
	_convertionFactor: number | null,
	_quantity: number
) {
	if (isNil(_convertionFactor)) {
		return 0;
	}
	const _decimalConvertionFactor = new Decimal(
		_convertionFactor
	);
	const _decimalQuantity = new Decimal(_quantity);

	const multiplication = Decimal.mul(
		_decimalConvertionFactor,
		_decimalQuantity
	);
	const result = multiplication.div(1000000);

	return result.toNumber();
}
